import React from 'react';
import { Panels } from './CosmeticRepairRequestTypes';
import SelectCarPanelImage from '../../../images/Car_Diagram.png';
import './SVGPanelSelector.scss';
import { t } from 'i18next';

export type SVGPanelSelectorProps = {
    selectedPanels: Panels[];
    onSelectionChange: (selected: boolean, panel: Panels) => void;
};

const SVGPanelSelector = ({
    selectedPanels,
    onSelectionChange
}: SVGPanelSelectorProps): JSX.Element => {
    return (
        <div style={{ height: 460, width: 1000 }}>
            <svg style={{ height: 460, width: 1000 }}>
                <defs>
                    <pattern
                        id='img1'
                        patternUnits='userSpaceOnUse'
                        x='0'
                        y='0'
                        width='1000'
                        height='700'>
                        <image
                            href={SelectCarPanelImage}
                            width='600'
                            height='450'
                        />
                    </pattern>
                </defs>
                <path
                    d='M5,5
        l0,680 l980,0 l0,-680 l-980,0'
                    fill='url(#img1)'
                />
                <path
                    d='m304,70l1,59l-38,-6.77049l-25,-18.37705l0,-32.88524l62,-0.96722z'
                    data-testid='front-driver-door'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontDriverDoor)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontDriverDoor
                            )
                                ? false
                                : true,
                            Panels.FrontDriverDoor
                        );
                    }}>
                    <title>{t('front_driver_door')}</title>
                </path>
                <path
                    d='m244,173c0,0 65,0 65,0c0,0 3,21 3,21c0,0 -35,-1 -35,-1c0,0 -33,-20 -33,-20z'
                    data-testid='front-driver-door'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontDriverDoor)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontDriverDoor
                            )
                                ? false
                                : true,
                            Panels.FrontDriverDoor
                        );
                    }}>
                    <title>{t('front_driver_door')}</title>
                </path>
                <path
                    d='m243,380c0,0 61,-1 61,-1c0,0 4,-54 4,-54c0,0 -34,4 -34,4c0,0 -31,21 -31,21c0,0 0,30 0,30z'
                    data-testid='front-passenger-door'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.FrontPassengerDoor
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontPassengerDoor
                            )
                                ? false
                                : true,
                            Panels.FrontPassengerDoor
                        );
                    }}>
                    <title>{t('front_passenger_door')}</title>
                </path>
                <path
                    d='m246,269.09524l30,-10.71429l33,-2.38095l-3,21.42857l-64,3.57143l4,-11.90476z'
                    data-testid='front-passenger-door'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.FrontPassengerDoor
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontPassengerDoor
                            )
                                ? false
                                : true,
                            Panels.FrontPassengerDoor
                        );
                    }}>
                    <title>{t('front_passenger_door')}</title>
                </path>
                <path
                    d='m309.0678,325c0,0 -4.0678,54 -4.0678,54c0,0 42.71187,0 42.71187,0c0,0 17.28814,-30.43636 17.28814,-30.43636c0,0 -16.27119,-21.6 -16.27119,-21.6c0,0 -39.66102,-1.96364 -39.66102,-1.96364z'
                    data-testid='rear-passenger-door'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.RearPassengerDoor
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearPassengerDoor
                            )
                                ? false
                                : true,
                            Panels.RearPassengerDoor
                        );
                    }}>
                    <title>{t('rear_passenger_wing')}</title>
                </path>
                <path
                    d='m310,256c0,0 -5,22 -5,22c0,0 52,0 52,0c0,0 8,-6.11111 8,-6.11111c0,0 -15,-14.66667 -15,-14.66667c0,0 -40,-1.22222 -40,-1.22222l0,-0.00001l0,0.00001z'
                    data-testid='rear-passenger-door'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.RearPassengerDoor
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearPassengerDoor
                            )
                                ? false
                                : true,
                            Panels.RearPassengerDoor
                        );
                    }}>
                    <title>{t('rear_passenger_wing')}</title>
                </path>
                <path
                    d='m302,70c0,0 2.06667,39.96774 2.06667,39.96774c0,0 3.1,19.03226 3.1,19.03226c0,0 39.26667,-0.95161 39.26667,-0.95161c0,0 17.56667,-20.93548 17.56667,-20.93548c0,0 -20.66667,-36.16129 -20.66667,-36.16129c0,0 -41.33333,-0.95161 -41.33333,-0.95161l-0.00001,0z'
                    data-testid='rear-driver-door'
                    className={
                        selectedPanels.find((p) => p == Panels.RearDriverDoor)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearDriverDoor
                            )
                                ? false
                                : true,
                            Panels.RearDriverDoor
                        );
                    }}>
                    <title>{t('rear_driver_door')}</title>
                </path>
                <path
                    d='m311,174l4,19l37,-1l14,-11l-7,-9l-48,2z'
                    data-testid='rear-driver-door'
                    className={
                        selectedPanels.find((p) => p == Panels.RearDriverDoor)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearDriverDoor
                            )
                                ? false
                                : true,
                            Panels.RearDriverDoor
                        );
                    }}>
                    <title>{t('rear_driver_door')}</title>
                </path>
                <path
                    d='m427.8492,191.19559l-26.98408,0c2.98058,0 5.39681,15.56339 5.39681,34.76181c0,19.19842 -2.41624,34.76181 -5.39681,34.76181l26.98408,0l0,0c2.98058,0 5.39681,-15.56339 5.39681,-34.76181c0,-19.19842 -2.41624,-34.76181 -5.39681,-34.76181z'
                    data-testid='boot'
                    className={
                        selectedPanels.find((p) => p == Panels.Boot)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Boot)
                                ? false
                                : true,
                            Panels.Boot
                        );
                    }}>
                    <title>{t('boot')}</title>
                </path>
                <path
                    d='m483.42638,181.58558l20.34722,0l0,0c2.66554,0 4.82639,19.25176 4.82639,43.00001c0,23.74823 -2.16085,42.99999 -4.82639,42.99999l-20.34722,0l0,0c-2.66554,0 -4.82639,-19.25175 -4.82639,-42.99999c0,-23.74825 2.16085,-43.00001 4.82639,-43.00001z'
                    data-testid='boot'
                    className={
                        selectedPanels.find((p) => p == Panels.Boot)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Boot)
                                ? false
                                : true,
                            Panels.Boot
                        );
                    }}>
                    <title>{t('boot')}</title>
                </path>
                <path
                    d='m400,340c0,0 21.81818,2 21.81818,2c0,0 0,20 0,20c0,0 18.18182,0 18.18182,0c0,0 -2.42424,-24 -2.42424,-24c0,0 -37.57576,2 -37.57576,2z'
                    data-testid='boot'
                    className={
                        selectedPanels.find((p) => p == Panels.Boot)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Boot)
                                ? false
                                : true,
                            Panels.Boot
                        );
                    }}>
                    <title>{t('boot')}</title>
                </path>
                <path
                    d='m441,86c0,0 -21,-1 -21,-1c0,0 -1,20 -1,20c0,0 -14,5 -14,5c0,0 31,-1 31,-1c0,0 5,-23 5,-23z'
                    data-testid='boot'
                    className={
                        selectedPanels.find((p) => p == Panels.Boot)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Boot)
                                ? false
                                : true,
                            Panels.Boot
                        );
                    }}>
                    <title>{t('boot')}</title>
                </path>
                <path
                    d='m185.01219,184.55927l60.61797,0c-6.69568,0 -12.12359,17.87241 -12.12359,39.91915c0,22.04674 5.42792,39.91915 12.12359,39.91915l-60.61797,0l0,0c-6.69568,0 -12.12359,-17.87241 -12.12359,-39.91915c0,-22.04674 5.42792,-39.91915 12.12359,-39.91915z'
                    data-testid='bonnet'
                    className={
                        selectedPanels.find((p) => p == Panels.Bonnet)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Bonnet)
                                ? false
                                : true,
                            Panels.Bonnet
                        );
                    }}>
                    <title>{t('bonnet')}</title>
                </path>
                <path
                    d='m185,363c0,0 5,-8 5,-8c0,0 54,-10 54,-10c0,0 -11,-2 -11,-2c0,0 -62,8 -62,8c0,0 -7,13 -7,13c0,0 21,-1 21,-1z'
                    data-testid='bonnet'
                    className={
                        selectedPanels.find((p) => p == Panels.Bonnet)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Bonnet)
                                ? false
                                : true,
                            Panels.Bonnet
                        );
                    }}>
                    <title>{t('bonnet')}</title>
                </path>
                <path
                    d='m236,104c0,0 -64,-8 -64,-8c0,0 -8,-13 -8,-13c0,0 20,2 20,2c0,0 5,7 5,7c0,0 37,8 37,8c0,0 10,4 10,4z'
                    data-testid='bonnet'
                    className={
                        selectedPanels.find((p) => p == Panels.Bonnet)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Bonnet)
                                ? false
                                : true,
                            Panels.Bonnet
                        );
                    }}>
                    <title>{t('bonnet')}</title>
                </path>
                <path
                    d='m108,176c0,0 1,95 1,95c0,0 12,-7.6 12,-7.6c0,0 -1,-77.9 -1,-77.9c0,0 -12,-9.5 -12,-9.5z'
                    data-testid='bonnet'
                    className={
                        selectedPanels.find((p) => p == Panels.Bonnet)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Bonnet)
                                ? false
                                : true,
                            Panels.Bonnet
                        );
                    }}>
                    <title>{t('bonnet')}</title>
                </path>
                <path
                    d='m81.57754,174.62061l25.09491,0l0,0c3.2875,0 5.95255,22.16191 5.95255,49.50001c0,27.33808 -2.66504,49.49999 -5.95255,49.49999l-25.09491,0l0,0c-3.2875,0 -5.95255,-22.1619 -5.95255,-49.49999c0,-27.3381 2.66505,-49.50001 5.95255,-49.50001z'
                    data-testid='front-bumper'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontBumper)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.FrontBumper)
                                ? false
                                : true,
                            Panels.FrontBumper
                        );
                    }}>
                    <title>{t('front_bumper')}</title>
                </path>
                <path
                    d='m159,63c0,0 24,0 24,0c0,0 3,20.8421 3,20.8421c0,0 -21,1.15789 -21,1.15789c0,0 -6,-22 -6,-22l0,0.00001z'
                    data-testid='front-bumper'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontBumper)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.FrontBumper)
                                ? false
                                : true,
                            Panels.FrontBumper
                        );
                    }}>
                    <title>{t('front_bumper')}</title>
                </path>
                <path
                    d='m165,364c0,0 21,1.23529 21,1.23529c0,0 -3,19.76471 -3,19.76471c0,0 -23,-1.23529 -23,-1.23529c0,0 5,-19.76471 5,-19.76471z'
                    data-testid='front-bumper'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontBumper)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.FrontBumper)
                                ? false
                                : true,
                            Panels.FrontBumper
                        );
                    }}>
                    <title>{t('front_bumper')}</title>
                </path>
                <path
                    d='m189,180c0,0 -20,22 -20,22c0,0 -2,24 -2,24c0,0 4,22 4,22c0,0 17,21 17,21c0,0 -11,-1 -11,-1c0,0 -15,-22 -15,-22c0,0 -2,-39 -2,-39c0,0 15,-24 15,-24c0,0 14,-3 14,-3z'
                    data-testid='front-bumper'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontBumper)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.FrontBumper)
                                ? false
                                : true,
                            Panels.FrontBumper
                        );
                    }}>
                    <title>{t('front_bumper')}</title>
                </path>
                <path
                    d='m510.21967,175.61562l7.46066,0l0,0c0.97737,0 1.76968,21.93806 1.76968,49.00001c0,27.06194 -0.79231,48.99999 -1.76968,48.99999l-7.46066,0l0,0c-0.97737,0 -1.76968,-21.93805 -1.76968,-48.99999c0,-27.06196 0.79231,-49.00001 1.76968,-49.00001z'
                    data-testid='rear-bumper'
                    className={
                        selectedPanels.find((p) => p == Panels.RearBumper)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.RearBumper)
                                ? false
                                : true,
                            Panels.RearBumper
                        );
                    }}>
                    <title>{t('rear_bumper')}</title>
                </path>
                <path
                    d='m400,65c0,0 0,9 0,9c0,0 19,0 19,0c0,0 0,10 0,10c0,0 22,1 22,1c0,0 -5,-16 -5,-16c0,0 -36,-4 -36,-4z'
                    data-testid='rear-bumper'
                    className={
                        selectedPanels.find((p) => p == Panels.RearBumper)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.RearBumper)
                                ? false
                                : true,
                            Panels.RearBumper
                        );
                    }}>
                    <title>{t('rear_bumper')}</title>
                </path>
                <path
                    d='m420,363c0,0 -1,10 -1,10c0,0 -20,1 -20,1c0,0 0,9 0,9c0,0 35,-2 35,-2c0,0 6,-18 6,-18c0,0 -20,0 -20,0z'
                    data-testid='rear-bumper'
                    className={
                        selectedPanels.find((p) => p == Panels.RearBumper)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.RearBumper)
                                ? false
                                : true,
                            Panels.RearBumper
                        );
                    }}>
                    <title>{t('rear_bumper')}</title>
                </path>
                <path
                    d='m242,380c0,0 105,-1 105,-1c0,0 1,10 1,10c0,0 -110,1 -110,1c0,0 4,-10 4,-10z'
                    data-testid='passenger-sill'
                    className={
                        selectedPanels.find((p) => p == Panels.PassengerSill)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.PassengerSill
                            )
                                ? false
                                : true,
                            Panels.PassengerSill
                        );
                    }}>
                    <title>{t('passenger_sill')}</title>
                </path>
                <path
                    d='m240,65l0,8.75l111,1.25l-2.84615,-10l-108.15385,0z'
                    data-testid='driver-sill'
                    className={
                        selectedPanels.find((p) => p == Panels.DriverSill)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.DriverSill)
                                ? false
                                : true,
                            Panels.DriverSill
                        );
                    }}>
                    <title>{t('driver_sill')}</title>
                </path>
                <path
                    d='m454.01703,194.52059l5.42593,0l0,0c0.71081,0 1.28704,14.10304 1.28704,31.5c0,17.39696 -0.57623,31.49999 -1.28704,31.49999l-5.42593,0l0,0c-0.71081,0 -1.28704,-14.10303 -1.28704,-31.49999c0,-17.39697 0.57623,-31.5 1.28704,-31.5z'
                    data-testid='roof'
                    className={
                        selectedPanels.find((p) => p == Panels.Roof)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Roof)
                                ? false
                                : true,
                            Panels.Roof
                        );
                    }}>
                    <title>{t('roof')}</title>
                </path>
                <path
                    d='m139.59703,187.5556l5.42593,0l0,0c0.71081,0 1.28704,14.99847 1.28704,33.5c0,18.50153 -0.57623,33.49999 -1.28704,33.49999l-5.42593,0l0,0c-0.71081,0 -1.28704,-14.99846 -1.28704,-33.49999c0,-18.50154 0.57623,-33.5 1.28704,-33.5z'
                    data-testid='roof'
                    className={
                        selectedPanels.find((p) => p == Panels.Roof)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Roof)
                                ? false
                                : true,
                            Panels.Roof
                        );
                    }}>
                    <title>{t('roof')}</title>
                </path>
                <path
                    d='m276,193c0,0 89.97753,0 89.97753,0c0,0 1.02247,64 1.02247,64c0,0 -89.97753,-1 -89.97753,-1c0,0 -1.02247,-63 -1.02247,-63z'
                    data-testid='roof'
                    className={
                        selectedPanels.find((p) => p == Panels.Roof)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Roof)
                                ? false
                                : true,
                            Panels.Roof
                        );
                    }}>
                    <title>{t('roof')}</title>
                </path>
                <path
                    d='m288.65126,318.89561l54.9375,0l0,0c7.19697,0 13.03125,0.89543 13.03125,2.00001c0,1.10457 -5.83429,2.00001 -13.03125,2.00001l-54.9375,0l0,0c-7.19696,0 -13.03125,-0.89543 -13.03125,-2.00001c0,-1.10457 5.83429,-2.00001 13.03125,-2.00001z'
                    data-testid='roof'
                    className={
                        selectedPanels.find((p) => p == Panels.Roof)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Roof)
                                ? false
                                : true,
                            Panels.Roof
                        );
                    }}>
                    <title>{t('roof')}</title>
                </path>
                <path
                    d='m290.83187,123.87562l51.54628,0l0,0c6.75271,0 12.22685,1.34315 12.22685,3c0,1.65685 -5.47414,3 -12.22685,3l-51.54628,0l0,0c-6.7527,0 -12.22685,-1.34315 -12.22685,-3c0,-1.65685 5.47415,-3 12.22685,-3z'
                    data-testid='roof'
                    className={
                        selectedPanels.find((p) => p == Panels.Roof)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find((p) => p == Panels.Roof)
                                ? false
                                : true,
                            Panels.Roof
                        );
                    }}>
                    <title>{t('roof')}</title>
                </path>
                <path
                    d='m196,385c0,0 -11,1 -11,-4c0,0 5,-30 5,-25c0,0 52,-8 52,-8c0,0 -3,36 -4,36a11.8 10, 90 0,0 -44,0'
                    data-testid='front-passenger-wing'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.FrontPassengerWing
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontPassengerWing
                            )
                                ? false
                                : true,
                            Panels.FrontPassengerWing
                        );
                    }}>
                    <title>{t('front_passenger_wing')}</title>
                </path>
                <path
                    d='m181,268l65,-1l-2,7l-51,2l-12,-8z'
                    data-testid='front-passenger-wing'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.FrontPassengerWing
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontPassengerWing
                            )
                                ? false
                                : true,
                            Panels.FrontPassengerWing
                        );
                    }}>
                    <title>{t('front_passenger_wing')}</title>
                </path>
                <path
                    d='m353,257c0,0 14,12 14,12c0,0 -6,7 -6,7c0,0 33,0 33,0c0,0 29,-7 29,-7c0,0 3,-9 3,-9c0,0 -73,-3 -73,-3z'
                    data-testid='rear-passenger-wing'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.RearPassengerWing
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearPassengerWing
                            )
                                ? false
                                : true,
                            Panels.RearPassengerWing
                        );
                    }}>
                    <title>{t('rear_passenger_wing')}</title>
                </path>
                <path
                    d='m351,376c0,0 15,-31 15,-31c0,0 17,-2 17,-2c0,0 -31,-16 -31,-16c0,0 17,2 17,2c0,0 31,12 31,12c0,0 21,1 21,1c0,0 0,31 0,31c0,0 -20,0 -20,0a12 10, 0 0,0 -47.005,0'
                    data-testid='rear-passenger-wing'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.RearPassengerWing
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearPassengerWing
                            )
                                ? false
                                : true,
                            Panels.RearPassengerWing
                        );
                    }}>
                    <title>{t('rear_passenger_wing')}</title>
                </path>
                <path
                    d='m457,258c0,0 26,15 26,15c0,0 10,5 10,5c0,0 19,-2 19,-2c0,0 -2,-7 -2,-7c0,0 -22,-3 -22,-3c0,0 -31,-8 -31,-8z'
                    data-testid='rear-passenger-wing'
                    className={
                        selectedPanels.find(
                            (p) => p == Panels.RearPassengerWing
                        )
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearPassengerWing
                            )
                                ? false
                                : true,
                            Panels.RearPassengerWing
                        );
                    }}>
                    <title>{t('rear_passenger_wing')}</title>
                </path>
                <path
                    d='m185,181l57,2l7,-3l-7,-6l-48,-2l-9,9z'
                    data-testid='front-driver-wing'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontDriverWing)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontDriverWing
                            )
                                ? false
                                : true,
                            Panels.FrontDriverWing
                        );
                    }}>
                    <title>{t('front_driver_wing')}</title>
                </path>
                <path
                    d='m183,62c0,0 4.7541,28.77778 4.7541,28.77778c0,0 9.5082,5.13889 9.5082,5.13889c0,0 43.7377,3.08333 43.7377,3.08333c0,0 0,-37.97222 -0.95082,-35.97222a10.55738,10 80 1 1 -48.63934,0z'
                    data-testid='front-driver-wing'
                    className={
                        selectedPanels.find((p) => p == Panels.FrontDriverWing)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.FrontDriverWing
                            )
                                ? false
                                : true,
                            Panels.FrontDriverWing
                        );
                    }}>
                    <title>{t('front_driver_wing')}</title>
                </path>
                <path
                    d='m358,173c0,0 8,5 8,5c0,0 -17,14 -17,14c0,0 75,-4 75,-4c0,0 -1,-7 -1,-7c0,0 -30,-8 -30,-8c0,0 -35,0 -35,0z'
                    data-testid='rear-driver-wing'
                    className={
                        selectedPanels.find((p) => p == Panels.RearDriverWing)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearDriverWing
                            )
                                ? false
                                : true,
                            Panels.RearDriverWing
                        );
                    }}>
                    <title>{t('rear_driver_wing')}</title>
                </path>
                <path
                    d='m349,74c0,0 16,30 16,30c0,0 16,3 16,3c0,0 -29,17 -29,17c0,0 50,-15 50,-15c0,0 14,-5 14,-5c0,0 1,-31 1,-31c0,0 -19,0 -19,0a10,10 0 1 1 -47.005,0'
                    data-testid='rear-driver-wing'
                    className={
                        selectedPanels.find((p) => p == Panels.RearDriverWing)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearDriverWing
                            )
                                ? false
                                : true,
                            Panels.RearDriverWing
                        );
                    }}>
                    <title>{t('rear_driver_wing')}</title>
                </path>
                <path
                    d='m459,191c0,0 15,-8 15,-8c0,0 12,-8 12,-8c0,0 26,-1 26,-1c0,0 -2,9 -2,9c0,0 -22,1 -22,1c0,0 -29,7 -29,7z'
                    data-testid='rear-driver-wing'
                    className={
                        selectedPanels.find((p) => p == Panels.RearDriverWing)
                            ? 'highlighted'
                            : 'normal'
                    }
                    onClick={() => {
                        onSelectionChange(
                            selectedPanels.find(
                                (p) => p == Panels.RearDriverWing
                            )
                                ? false
                                : true,
                            Panels.RearDriverWing
                        );
                    }}>
                    <title>{t('rear_driver_wing')}</title>
                </path>
            </svg>
        </div>
    );
};

export default SVGPanelSelector;
